const BADGES = [
  {
    id: 1,
    name: 'love_us',
    src: 'love_us',
    background: ' #DB9A39',
  },
  {
    id: 2,
    name: 'trendy',
    src: 'trendy_1',
    background: '#FF8000',
  },
  {
    id: 3,
    name: 'trusted',
    src: 'trusted',
    background: '#FF6B00',
  },
  {
    id: 4,
    name: 'celebrity',
    src: 'celebrity',
    background: '#FF0F00',
  },
  {
    id: 5,
    name: 'role_model',
    src: 'role_model',
    background: '#95579F',
  },
  {
    id: 6,
    name: 'friendly',
    src: 'friendly',
    background: '#4D59A3',
  },
  {
    id: 7,
    name: 'transparent',
    src: 'transparent',
    background: '#4D5EA2',
  },
  {
    id: 8,
    name: 'helpful',
    src: 'helpful',
    background: '#4378D0',
  },
  {
    id: 9,
    name: 'popular',
    src: 'popular_4',
    background: '#1F6370',
  },
];

export const BADGES_LANGUAGES = ['pl', 'en', 'cs', 'sk'];

export type BadgeProps = {
  badgeName: string;
  urlName: string;
  withHeader: boolean;
  background: string;
  onTransition: boolean;
};

export default BADGES;
